import { Chip } from "@mui/material";
import { useRecordContext } from "react-admin";


export const CountriesListField = () => {
    const record = useRecordContext();
    return (
        <div>
            {record?.countries?.map((country: string) => <Chip size="small" key={country} label={country} />)}
        </div>
    )
}